module.exports = __webpack_public_path__ + "static/bad-ux-watercan-ed621f91102a97f8f0d818951d50ceb5.png";